import { ShieldAlert } from "lucide-react";
import { cn } from "../../lib/cn.js";

export interface PermissionStateProps {
  title?: string;
  description?: string;
  className?: string;
}

/**
 * Shown instead of an empty state when the user lacks permission, per
 * `07_UI_UX_SPEC.md` §25: "no permission: do not use an empty state; show permission state".
 */
export function PermissionState({
  title = "You don't have access to this",
  description = "Your account doesn't have permission to view this content. Contact an administrator if you believe this is a mistake.",
  className,
}: PermissionStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-[var(--radius-panel)] border border-border bg-surface-muted px-6 py-12 text-center",
        className,
      )}
    >
      <div className="flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <ShieldAlert className="size-5" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium text-foreground">{title}</p>
        <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
